import { motion } from "framer-motion";

import { content } from "../../content/content";
import { newsletters } from "../../data/newsletters";
import { fadeUp, staggerContainer } from "../../hooks/useScrollReveal";

export function Newsletters() {
  return (
    <section
      id="newsletters"
      className="paper-grain bg-warm-white py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          className="mb-14 max-w-2xl"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p
            data-edit-id="content.newsletters.eyebrow"
            className="mb-4 font-body text-xs font-medium tracking-[0.22em] text-violet uppercase"
          >
            {content.newsletters.eyebrow}
          </p>
          <h2
            data-edit-id="content.newsletters.headline"
            className="text-balance font-display text-[clamp(2rem,4vw,3.5rem)] text-ink"
          >
            {content.newsletters.headline}
          </h2>
          <p
            data-edit-id="content.newsletters.intro"
            className="mt-4 font-body text-lg text-ink-muted"
          >
            {content.newsletters.intro}
          </p>
        </motion.div>

        <motion.div
          className="grid gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-4"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {newsletters.map((edition, index) => (
            <motion.a
              key={edition.id}
              data-edit-id={`data.newsletters[${edition.id}]`}
              href={edition.pdf}
              target="_blank"
              rel="noopener noreferrer"
              download={`SE Newsletter Edition ${edition.number}.pdf`}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-ink/10 bg-warm-white transition-colors duration-300 hover:border-saffron-dark"
              variants={fadeUp}
            >
              {index === 0 && (
                <span
                  data-edit-id="content.newsletters.latestBadge"
                  className="absolute top-3 right-3 z-10 rounded-xl bg-violet px-2.5 py-1 font-body text-[10px] font-medium tracking-[0.22em] text-warm-white uppercase"
                >
                  {content.newsletters.latestBadge}
                </span>
              )}
              <div className="aspect-[3/4] overflow-hidden border-b border-ink/10 bg-warm-cream">
                <img
                  data-edit-id={`data.newsletters[${edition.id}].thumbnail`}
                  src={edition.thumbnail}
                  alt={`Sadafal Education newsletter, ${edition.title}`}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-1 flex-col gap-2.5 p-6">
                <p
                  data-edit-id={`data.newsletters[${edition.id}].period`}
                  className="font-body text-[10px] font-medium tracking-[0.22em] text-saffron-dark uppercase"
                >
                  {edition.period ?? edition.title}
                </p>
                <h3
                  data-edit-id={`data.newsletters[${edition.id}].title`}
                  className="font-display text-xl text-ink md:text-2xl"
                >
                  {edition.title}
                </h3>
                <p
                  data-edit-id={`data.newsletters[${edition.id}].blurb`}
                  className="font-body text-sm leading-relaxed text-ink-muted"
                >
                  {edition.blurb}
                </p>
                <p
                  data-edit-id="content.newsletters.downloadLabel"
                  className="mt-auto inline-flex items-center gap-2 pt-2 font-body text-sm font-medium text-saffron-dark transition-opacity group-hover:opacity-70"
                >
                  {content.newsletters.downloadLabel}
                  <span aria-hidden="true">→</span>
                </p>
              </div>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
